import {
  CANDIDATE_PRO_IMG_REQUEST,
  CANDIDATE_PRO_IMG_SUCCESS,
  CANDIDATE_PRO_IMG_FAIL
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_PATH;

export const CandidateUpdateProImg = (data) => {
  return function (dispatch) {
    dispatch({
      type: CANDIDATE_PRO_IMG_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${baseUrl}/ebench/upload_candidate_profile`,
      method: "PUT",
      data: data,
      headers: {
        "content-Type": "multipart/form-data",
      },
    };

    // Return the promise from axios
    return axios(OPTION)
      .then((res) => {
        dispatch(uploadProimgPre(res.data));
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        dispatch({
          type: CANDIDATE_PRO_IMG_FAIL,
          payload: false,
          error: error,
          uploadProImg: error.success,
          msg: "Failed to Upload",
        });
        toast.error(error.response.data.status.message);
        return Promise.reject(error);
      });
  };
};

export const uploadProimgPre = (data) => {
  toast.success("Upload Successfully!");
  return {
    type: CANDIDATE_PRO_IMG_SUCCESS,
    uploadProImg: data.status.message,
    result: data.data,
    payload: false,
    msg: data.status.message,
  };
};
